import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Layers, PhoneCall } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import FacilityManagement from "@/components/site/FacilityManagement";

export default function FacilityManagementPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="facility-management-page" className="bg-white text-[#050B14]">
      <Navigation />

      <main>
        <section className="relative bg-[#F4F8FC] pt-40 md:pt-48 pb-16 md:pb-20 border-b border-[#E5EBF2] overflow-hidden">
          <div className="relative container-ags">
            <Link
              to="/"
              className="group inline-flex items-center gap-2 text-sm font-medium text-[#0E2A57] hover:text-[#2BB6E5] transition-colors mb-8"
            >
              <ArrowLeft size={16} className="transition-transform group-hover:-translate-x-1" />
              Back to home
            </Link>

            <div className="grid md:grid-cols-12 gap-10 items-end">
              <div className="md:col-span-8">
                <div className="flex items-center gap-3 mb-5">
                  <span className="h-px w-16 bg-[#2BB6E5]" />
                  <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
                    Facility Management
                  </span>
                </div>
                <h1 className="font-heading font-extrabold text-5xl md:text-7xl leading-[1.0] tracking-[-0.04em] text-[#0E2A57] max-w-4xl">
                  One contract for your{" "}
                  <span className="italic-display font-normal text-[#2BB6E5]">
                    entire facility
                  </span>
                  .
                </h1>
                <p className="mt-8 text-[#475569] text-lg md:text-xl leading-relaxed max-w-2xl">
                  A complete commercial Facility Management package across
                  Ireland — for hotels, offices, warehouses, and industrial
                  sites. Cleaning, maintenance, and repairs, all under one
                  accountable family-owned team.
                </p>
              </div>
              <div className="md:col-span-4 flex md:justify-end">
                <div className="bg-white border border-[#E5EBF2] px-6 py-5 inline-flex items-center gap-4">
                  <span className="bg-[#0E2A57] text-white w-12 h-12 flex items-center justify-center">
                    <Layers size={22} />
                  </span>
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#475569] font-medium">
                      All-in-one
                    </div>
                    <div className="font-heading font-bold text-2xl text-[#0E2A57]">
                      13 services
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FacilityManagement />

        <section className="bg-white py-16 md:py-24 border-t border-[#E5EBF2]">
          <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
              Get in touch
            </span>
            <h2 className="mt-4 font-heading font-extrabold text-4xl md:text-5xl leading-[1.05] tracking-[-0.04em] text-[#0E2A57]">
              Ready to consolidate your facility?
            </h2>
            <p className="mt-6 text-[#475569] text-lg leading-relaxed max-w-2xl mx-auto">
              Get a free, no-obligation quote for your Facility Management
              Package in Ireland today.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <Link
                to="/quote"
                data-testid="fm-cta-quote"
                className="group inline-flex items-center gap-3 bg-[#0E2A57] text-white hover:bg-[#081A37] px-10 py-5 font-semibold tracking-wide transition-colors"
              >
                Get a Free Quote
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-3 border-2 border-[#0E2A57] text-[#0E2A57] hover:bg-[#0E2A57] hover:text-white px-10 py-5 font-semibold tracking-wide transition-all"
              >
                <PhoneCall size={16} />
                Talk to us first
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
